import LeadersTeam from "@/components/layout/network/detailed/LeadersTeam";

const Detailed = () => {
  return (
    <div className="flex-1 flex flex-col items-center gap-3 px-4 pb-40 pt-4">
      <LeadersTeam />
    </div>
  );
};

export default Detailed;
